import { posServiceInstance } from './api';

const BASE = '/customer/tier-config';

export const getTierConfig = (businessGroupUuid) =>
  posServiceInstance.get(`${BASE}/${businessGroupUuid}`).then((r) => r.data);

export const updateTierConfig = (businessGroupUuid, data) =>
  posServiceInstance.put(`${BASE}/${businessGroupUuid}`, data).then((r) => r.data);

export const deleteTierConfig = (businessGroupUuid) =>
  posServiceInstance.delete(`${BASE}/${businessGroupUuid}`).then((r) => r.data);
